<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col class="mb-1">
          <router-link :to="{ name: 'EXCMTaskTypeList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-tabs v-model="tabIndex">
              <b-tab :title="$t('views.excmtasktype.create.title')">
                <EXCMTaskTypeForm
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
              </b-tab>
              <b-tab :title="$t('views.excmtasktype.create.titleRoles')">
                <CreateRolesForTaskType
                  :values="item"
                  @roleWithPermissions="item.allowedAccessRole = $event">
                </CreateRolesForTaskType>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMTaskTypeForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import CreateRolesForTaskType from './CreateRolesForTaskType'

const { mapGetters, mapActions } = createNamespacedHelpers('excmtasktype/create')

export default {
  components: {
    EXCMTaskTypeForm,
    Loader,
    CreateRolesForTaskType
  },

  data () {
    return {
      tabIndex: [],
      item: {
        disabledRoles: [],
        conditionsAdd: [],
        customFields: [],
        durationUnit: 1,
        taskParams: {
          canBeDailyPlanItem: true,
          autoDispatch: true,
          autoStartAfterTake: true,
          autoCloseCase: false,
          canHaveDocument: false
        },
        color: '',
        actionTakenAfterDeadlineExceeded: 0,
        tasksToCreateAfterDeadlineExceeded: [],
        poolTaskRecipient: 0,
        daysToCreateTaskAfterDeadlineExceeded: 0,
        poolTaskRecipientDuringCreating: 0
      }
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMTaskTypeList' })
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMTaskTypeCreate')
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      // if (item.cost) {
      //   item.cost = parseFloat(item.cost)
      // } else {
      //   item.cost = parseFloat('0.00')
      // }
      item.duration = parseInt(item.duration)
      item.groups = parseInt(item.groups)
      item.notification = parseInt(item.notification)
      item.notificationEnable = parseInt(item.notificationEnable)
      item.alarm = parseInt(item.alarm)
      item.alarmEnable = parseInt(item.alarmEnable)
      item.alarmNotFinishedEnable = parseInt(item.alarmNotFinishedEnable)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
